import { defineAsyncComponent } from 'vue'
export default {
  another: defineAsyncComponent(() => import("/portal-nuxt-app/layouts/another.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/portal-nuxt-app/layouts/default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/portal-nuxt-app/layouts/guest.vue").then(m => m.default || m)),
  search: defineAsyncComponent(() => import("/portal-nuxt-app/layouts/search.vue").then(m => m.default || m))
}